module.exports = __webpack_public_path__ + "img/PTFvsLDE.63e41284.png";